import { Tabs } from '@mantine/core';
import DataTable from "react-data-table-component";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import Loader from "react-js-loader";
import {AiOutlineEye} from 'react-icons/ai'
import Sidebar from '../../components/dashboard/sidebar';
import "../../Styles/dashboard/orders.css"
import { orderColumns } from '../../components/dashboard/data';

const OrdersDashboard = () => {
    // get request for all order, with 3 states, pending, delivered, cancelled, all
    const [orders, setOrders] = useState([])
    const [fetch, setFetched] = useState(false)
    const navigate = useNavigate()

    useEffect(() => {
        setFetched(true)
    }, [])

    return <>
        <Sidebar/>
        {
            !fetch ?
            <div className="loader">
                <Loader type="box-rectangular" bgColor={"rgb(190,142,30)"} title={"box-rotate-x"} color={'green'} size={50} />
            </div> :
        
        <div className="ordersWrapper">
            <div className="topOrdersCard">
                <div className="orderCardInfo">
                    <p>New Orders</p>
                    <h2>5</h2>
                </div>
                <div className="orderCardInfo">
                    <p>Pending Orders</p>
                    <h2>10</h2>
                </div>
                <div className="orderCardInfo">
                    <p>Delivered Orders</p>
                    <h2>6</h2>
                </div>
                <div className="orderCardInfo">
                    <p>Cancelled Orders</p>
                    <h2  style={{color: "red"}}>3</h2>
                </div>
            </div>

            <div className="orderTables">
                <Tabs color="green" defaultValue="all">
                    <Tabs.List grow position="apart">
                        <Tabs.Tab value="all" className="tab">All Orders</Tabs.Tab>
                        <Tabs.Tab value="pending" className="tab">Pending Orders</Tabs.Tab>
                        <Tabs.Tab value="delivered" className="tab">Delivered Orders</Tabs.Tab>
                        <Tabs.Tab value="cancelled" className="tab">Cancelled Orders</Tabs.Tab>
                    </Tabs.List>

                    <Tabs.Panel value="all" pt="xs">
                        <DataTable
                            columns={orderColumns}
                            data={
                                orders.map((data => {
                                    return ({
                                        id: "#" + data.id,
                                        userName: <p style={{textWrap: 'wrap'}}>{data.user.firstname ? data.user.firstname + " " + data.user.lastname : data.user.username}</p> ,
                                        totalPrice: <p style={{textWrap: 'wrap'}}>N{data.totalPrice}</p> ,
                                        deliveryType: <p style={{textWrap: 'wrap'}}>{data.deliveryType}</p> ,
                                        address: data.deliveryType === "DELIVERY" && data.address ? <p style={{textWrap: 'wrap'}}>{`${data.address.streetAddress} ${data.address.city} ${data.address.state}`}</p>    : <p style={{textWrap: 'wrap'}}>Edyco's Plaza, First Mechanic Junction, Choba, port Harcourt</p> ,
                                        status: <p style={{textWrap: 'wrap'}}>{data.status}</p> ,
                                        paymentStatus: <p style={{textWrap: 'wrap'}}>{data.payment ? data.payment.status : "Not Paid"}</p> ,
                                        dateOrdered: <p style={{textWrap: 'wrap'}}>{new Date(data.dateOrdered).toDateString()}</p>,
                                        view: <AiOutlineEye style={{fontSize: '17px', cursor: 'pointer'}} onClick={() => navigate(`/dashboard/orders/${data.id}`)}/> 
                                    })
                                }))
                            }
                            pagination
                            responsive
                            striped
                            
                        />
                    </Tabs.Panel>

                    <Tabs.Panel value="pending" pt="xs">
                    <DataTable
                            columns={orderColumns}
                            data={
                                orders.filter(el => el.status === "PENDING").map((data => {
                                    return ({
                                        id: "#" + data.id,
                                        userName: <p style={{textWrap: 'wrap'}}>{data.user.firstname ? data.user.firstname + " " + data.user.lastname : data.user.username}</p> ,
                                        totalPrice: <p style={{textWrap: 'wrap'}}>N{data.totalPrice}</p> ,
                                        deliveryType: <p style={{textWrap: 'wrap'}}>{data.deliveryType}</p> ,
                                        address: data.deliveryType === "DELIVERY" && data.address ? <p style={{textWrap: 'wrap'}}>{`${data.address.streetAddress} ${data.address.city} ${data.address.state}`}</p>    : <p style={{textWrap: 'wrap'}}>{"Edyco's Plaza, First Mechanic Junction, Choba, port Harcourt"}</p> ,
                                        status: <p style={{textWrap: 'wrap'}}>{data.status}</p> ,
                                        paymentStatus: <p style={{textWrap: 'wrap'}}>{data.payment ? data.payment.status : "Not Paid"}</p> ,
                                        dateOrdered: <p style={{textWrap: 'wrap'}}>{new Date(data.dateOrdered).toDateString()}</p> ,
                                        view: <AiOutlineEye style={{fontSize: '17px', cursor: 'pointer'}} onClick={() => navigate(`/dashboard/orders/${data.id}`)}/> 
                                    })
                                }))
                            }
                            pagination
                            responsive
                            striped
                            
                        />
                    </Tabs.Panel>

                    <Tabs.Panel value="delivered" pt="xs">
                    <DataTable
                            columns={orderColumns}
                            data={
                                orders.filter(el => el.status === "DELIVERED").map((data => {
                                    return ({
                                        id: "#" + data.id,
                                        userName: <p style={{textWrap: 'wrap'}}>{data.user.firstname ? data.user.firstname + " " + data.user.lastname : data.user.username}</p> ,
                                        totalPrice: <p style={{textWrap: 'wrap'}}>N{data.totalPrice}</p> ,
                                        deliveryType: <p style={{textWrap: 'wrap'}}>{data.deliveryType}</p> ,
                                        address: data.deliveryType === "DELIVERY" && data.address ? <p style={{textWrap: 'wrap'}}>{`${data.address.streetAddress} ${data.address.city} ${data.address.state}`}</p>    : <p style={{textWrap: 'wrap'}}>{"Edyco's Plaza, First Mechanic Junction, Choba, port Harcourt"}</p> ,
                                        status: <p style={{textWrap: 'wrap'}}>{data.status}</p> ,
                                        paymentStatus: <p style={{textWrap: 'wrap'}}>{data.payment ? data.payment.status : "Not Paid"}</p> ,
                                        dateOrdered: <p style={{textWrap: 'wrap'}}>{new Date(data.dateOrdered).toDateString()}</p> ,
                                        view: <AiOutlineEye style={{fontSize: '17px', cursor: 'pointer'}} onClick={() => navigate(`/dashboard/orders/${data.id}`)}/> 
                                    })
                                }))
                            }
                            pagination
                            responsive
                            striped
                            
                        />
                    </Tabs.Panel>

                    <Tabs.Panel value="cancelled" pt="xs">
                    <DataTable
                            columns={orderColumns}
                            data={
                                orders.filter(el => el.status === "CANCELLED").map((data => {
                                    return ({
                                        id: "#" + data.id,
                                        userName: <p style={{textWrap: 'wrap'}}>{data.user.firstname ? data.user.firstname + " " + data.user.lastname : data.user.username}</p> ,
                                        totalPrice: <p style={{textWrap: 'wrap'}}>N{data.totalPrice}</p> ,
                                        deliveryType: <p style={{textWrap: 'wrap'}}>{data.deliveryType}</p> ,
                                        address: data.deliveryType === "DELIVERY" && data.address ? <p style={{textWrap: 'wrap'}}>{`${data.address.streetAddress} ${data.address.city} ${data.address.state}`}</p>    : <p style={{textWrap: 'wrap'}}>{"Edyco's Plaza, First Mechanic Junction, Choba, port Harcourt"}</p> ,
                                        status: <p style={{textWrap: 'wrap'}}>{data.status}</p> ,
                                        paymentStatus: <p style={{textWrap: 'wrap'}}>{data.payment ? data.payment.status : "Not Paid"}</p> ,
                                        dateOrdered: <p style={{textWrap: 'wrap'}}>{new Date(data.dateOrdered).toDateString()}</p> 
                                    })
                                }))
                            }
                            pagination
                            responsive
                            striped
                            
                        />
                    </Tabs.Panel>

                </Tabs>
            </div>

        </div>
        }
    </>

}

export default OrdersDashboard